import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseSpacerTokens = {};
//
// Helpers
//
export const CFBaseSpacerHelpers = {
    size: ({ bufferedProps: { dir, size } }) => {
        const width = dir === 'vertical'
            ? 0
            : CFTokens.getCFSpacerValue((size || 0));
        const height = dir === 'horizontal'
            ? 0
            : CFTokens.getCFSpacerValue((size || 0));
        return css `
      width: ${width}px;
      height: ${height}px;
    `;
    },
};
//
// Element Styles
//
export const CFBaseSpacerStyles = {
    Root: css `
    box-sizing: border-box;
    display: flex;
    background-color: transparent;
    ${CFBaseSpacerHelpers.size};
  `,
};
